export const tableHeaderData_Desktop = [
  { label: "Date Created", cellWidth: "226px" },
  { label: "Product Name", cellWidth: "228px" },
  { label: "Amount", cellWidth: "175px" },
  { label: "Status", cellWidth: "130px" },
  { label: "QR Code and Link", cellWidth: "154px" },
  { label: "", cellWidth: "160px" },
  { label: "", cellWidth: "57px" },
];

export interface TableBodyItem {
  dateCreated: string;
  productName: string;
  amount: string;
  status: string;
  qRCode: string;
  button1: string;
  button2: string;
}

export const tableHeaderData_Mobile = [
  { label: "Date Created", cellWidth: "226px" },
  { label: "Product Name", cellWidth: "228px" },
  { label: "Amount", cellWidth: "175px" },
  { label: "Status", cellWidth: "130px" },
  { label: "QR Code and Link", cellWidth: "154px" },
  { label: "", cellWidth: "160px" },
  { label: "", cellWidth: "57px" },
];

export const TableBodyData: TableBodyItem[] = [
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "d20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Inactive",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
  {
    dateCreated: "20 Dec 2023",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    status: "Active",
    qRCode: "QR Code",
    button1: "Copy Link",
    button2: "button2",
  },
];
